import AsyncStorage from '@react-native-async-storage/async-storage'
import { offline } from '@redux-offline/redux-offline'
import { Platform } from 'react-native'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { combineEpics, createEpicMiddleware } from 'redux-observable'
import { SETTINGS_ACCEPTED_TERMS_AND_CONDITIONS_VERSION } from '~constants/Settings'
import { authEpic, authReducer, setTermsAndConditions } from './auth'
import chatReducer, { chatEpic } from './chat/chatSlice'
import { groupReducer } from './group/reducer'
import middlewares from './middlewares'
import { recentReducer } from './recent'
import reduxOfflineConfig from './reduxOfflineConfig'
import { storageReducer } from './storage/reducer'

const VERSION_REDUCER_KEY = 'appVersion'

export const rootEpic = combineEpics(authEpic, chatEpic)

export const rootReducer = combineReducers({
  [VERSION_REDUCER_KEY]: (state = { version: -1 }) => state,
  auth: authReducer,
  chat: chatReducer,
  group: groupReducer,
  recent: recentReducer,
  storage: storageReducer,
})

const epicMiddleware = createEpicMiddleware()

const myMiddlewares = [...middlewares]

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

reduxOfflineConfig.persistCallback = () => {
  AsyncStorage.getItem(SETTINGS_ACCEPTED_TERMS_AND_CONDITIONS_VERSION).then((value) => {
    if (typeof value === 'string') {
      store.dispatch(setTermsAndConditions(value))
    }
  })
}

const store = offline(reduxOfflineConfig)(createStore)(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(...myMiddlewares), applyMiddleware(epicMiddleware)),
)

epicMiddleware.run(rootEpic)

if (Platform.OS === 'web') {
  reduxOfflineConfig.persistCallback()
}

export type ApplicationState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed dispatch
export const useTypedDispatch: () => AppDispatch = useDispatch

// Typed selector
export const useTypedSelector: TypedUseSelectorHook<ApplicationState> = useSelector

export default store
